import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { "data-test": "nmr-message" }
const _hoisted_3 = {
  key: 0,
  class: "text-success text-big",
  style: {"margin-right":"10px"},
  "data-test": "nmr-added-users"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-ok" }, null, -1)
const _hoisted_5 = ["disabled"]

import { Modal } from "uiv";
import { computed, ref } from "vue";
import SearchUsers from "./search-users.vue";
import { GroupUserRoles } from "./group-user-roles.enum";
import {
  GroupUserRoleApiModel,
  ShortUserDetailsApiModel,
  TeamCurrentMemberApiModel,
} from "../../../api-models";
import { useAxios } from "../../../composables/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'add-non-member-role-modal',
  props: {
    role: {},
    modelValue: { type: Boolean },
    existingMembers: {},
    teamId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedUser = ref<ShortUserDetailsApiModel | null>(null);

const addedUsers = ref<ShortUserDetailsApiModel[]>([]);

const isLoading = ref(false);

const isSaving = ref(false);

const errors = ref<string[]>([]);

const shown = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const memberList = computed<ShortUserDetailsApiModel[]>(() => {
  return props.existingMembers.map((m) => {
    return m.userDetails;
  });
});

const selectUser = (selection: ShortUserDetailsApiModel): void => {
  selectedUser.value = selection;
};

const assignUserToRole = (): void => {
  if (selectedUser.value) {
    isSaving.value = true;
    const userFullName = `${selectedUser.value.firstName} ${selectedUser.value.lastName}`;
    const editUserRole: GroupUserRoleApiModel = {
      id: selectedUser.value.id,
      groupId: props.teamId,
      name: userFullName,
      role: props.role.toLowerCase(),
    };
    const { errorStatus } = useAxios("/api/admin/teamrole", {
      isFatal: false,
      httpMethod: "POST",
      data: editUserRole,
    });
    if (errorStatus.value) {
      errors.value = ["There was a problem assigning this user, please try again."];
    } else if (selectedUser.value) {
      addedUsers.value.push(selectedUser.value);
    }
    isSaving.value = false;
    selectedUser.value = null;
  }
};

const close = (): void => {
  let isRefreshNeeded = false;
  if (addedUsers.value.length) {
    isRefreshNeeded = true;
  }
  emit("update:modelValue", isRefreshNeeded);
  selectedUser.value = null;
  addedUsers.value = [];
};

const updateSearchState = (isSearching: boolean): void => {
  isLoading.value = isSearching;
};

return (_ctx: any,_cache: any) => {
  return (_ctx.role && shown.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        class: "organisation-member-add-dialog text-left",
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shown).value = $event)),
        title: `Add ${_ctx.role}s to this team`,
        "data-test": "nmr-modal"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            (addedUsers.value.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _hoisted_4,
                  _createTextVNode(" Added " + _toDisplayString(addedUsers.value.length) + " " + _toDisplayString(addedUsers.value.length > 1 ? _ctx.role + "s" : _ctx.role), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (assignUserToRole())),
              disabled: !selectedUser.value || isLoading.value || isSaving.value,
              "data-test": "nmr-add-btn",
              type: "button"
            }, _toDisplayString(isSaving.value ? "Saving..." : "Add"), 9, _hoisted_5),
            _createElementVNode("button", {
              class: "btn btn-default",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (close())),
              "data-test": "nmr-close-btn",
              type: "button"
            }, " Close ")
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(SearchUsers, {
            errors: errors.value,
            existingMembers: memberList.value,
            onSelectUser: selectUser,
            onUpdateSearchState: updateSearchState
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, "Add " + _toDisplayString(_ctx.role) + "s who do not belong to this team.", 1)
              ])
            ]),
            _: 1
          }, 8, ["errors", "existingMembers"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}
}

})